import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetadataTemplates = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 2.75H6.5C5.5335 2.75 4.75 3.5335 4.75 4.5V19.5C4.75 20.4665 5.5335 21.25 6.5 21.25H17.5C18.4665 21.25 19.25 20.4665 19.25 19.5V9L13 2.75Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 3V8.25C12.75 8.8023 13.1977 9.25 13.75 9.25H19",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.75H15.5",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15.75L10 14.1H16V17.4H10L8 15.75Z",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.7,
			cy: 15.75,
			r: .75,
			fill: "currentColor"
		})
	]
});
export default SvgMetadataTemplates;
